var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import parseAndSortData from '../../utils/sortData';
import normalizeSeries from '../../utils/normalizeSeries';
import buildPieConfiguration from './builders/pie';
import buildMultiAxisConfiguration from './builders/multiAxis';
import buildPackedBubbleConfiguration from './builders/packedbubble';
import buildHistogramConfiguration from './builders/histogram';
import buildBulletConfiguration from './builders/bullet';
import trendLines from '../../utils/trendLines';
import { buildGaugeConfiguration, buildGaugeTargetLineConfiguration } from './builders/gauge';
import buildFunnelChartConfiguration from './builders/funnel';
import buildSankeyConfiguration from './builders/sankey';
import buildPyramidChartConfiguration from './builders/pyramid';
import buildHeatmapConfiguration from './builders/heatmap';
import constants from '../constants';
import buildTreemapConfiguration from './builders/treemap';
import buildXRangeConfiguration from './builders/xrange';

var configureSeries = function configureSeries(widgetConfig, seriesDataObj, customConfig) {
    var seriesConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var ChartConfig = widgetConfig.ChartConfig,
        BubbleChartConfig = widgetConfig.BubbleChartConfig,
        HistogramConfig = widgetConfig.HistogramConfig,
        GaugeConfig = widgetConfig.GaugeConfig,
        BulletConfig = widgetConfig.BulletConfig,
        FlowConfig = widgetConfig.FlowConfig,
        HeatmapConfig = widgetConfig.HeatmapConfig,
        TreemapConfig = widgetConfig.TreemapConfig,
        XRangeConfig = widgetConfig.XRangeConfig;

    var configArr = [];

    var series = normalizeSeries(widgetConfig, seriesDataObj);
    var seriesData = parseAndSortData(series, widgetConfig, seriesDataObj);

    if (ChartConfig) {
        (function () {
            var labelField = ChartConfig.LabelField;

            var _loop = function _loop(index) {
                var currentSeries = series[index];

                if (currentSeries.IsTrendLine) return 'continue';

                var currentData = seriesData[currentSeries.SeriesName];

                if (!currentData) return 'continue';

                labelField = !labelField && currentSeries.XValueField ? currentSeries.XValueField : labelField;

                var trendSeriesName = currentSeries.SeriesName + " - Trend";

                var yField = currentSeries.YValueField || currentSeries.FieldName;

                if (trendLines.isSupported(ChartConfig.ChartType, currentSeries.SeriesType, series, currentData)) {

                    var xName = null;

                    if (currentSeries.SeriesType == "ScatterPlot") xName = currentSeries.XValueField;

                    var coefficients = trendLines.computeLinearTrend(currentData, xName, yField);

                    var slope = coefficients.slope,
                        intercept = coefficients.intercept;


                    var tempData = currentData.map(function (d, index) {
                        var xValue = d[labelField];
                        var yValue = slope * (index + 1) + intercept;

                        var tempResult = {};
                        tempResult[labelField] = xValue;
                        tempResult[yField] = yValue;

                        return tempResult;
                    });

                    seriesData[trendSeriesName] = tempData;
                }
            };

            for (var index = 0; index < series.length; index++) {
                var _ret2 = _loop(index);

                if (_ret2 === 'continue') continue;
            }
        })();
    }

    if (HistogramConfig) {
        configArr.push(buildHistogramConfiguration(widgetConfig, seriesData));
    } else if (HeatmapConfig) {
        var custom = typeof customConfig == 'function' ? customConfig(HeatmapConfig) : customConfig || {};
        configArr.push(buildHeatmapConfiguration(HeatmapConfig, series[0], seriesData, custom));
    } else if (BubbleChartConfig) {
        var _custom = typeof customConfig == 'function' ? customConfig(BubbleChartConfig) : customConfig || {};
        configArr.push(buildPackedBubbleConfiguration(BubbleChartConfig, series[0], seriesData, _custom));
    } else if (GaugeConfig) {
        var _custom2 = typeof customConfig == 'function' ? customConfig(GaugeConfig) : customConfig || {};
        configArr.push(buildGaugeConfiguration(GaugeConfig, series[0], seriesData, _custom2));
        configArr.push(buildGaugeTargetLineConfiguration(GaugeConfig, series[0], seriesData));
    } else if (FlowConfig) {
        var _custom3 = typeof customConfig == 'function' ? customConfig(FlowConfig) : customConfig || {};
        configArr.push(buildSankeyConfiguration(FlowConfig, series[0], seriesData, _custom3));
    } else if (widgetConfig.Type.toLowerCase() === 'bullet') {
        if (widgetConfig.BulletConfig.Series[0].CategoryAxis) configArr.push(buildBulletConfiguration(widgetConfig, BulletConfig, seriesData, customConfig(seriesConfig), seriesConfig));else configArr.push(buildBulletConfiguration(widgetConfig, seriesConfig, seriesData, customConfig(seriesConfig)));
    } else if (TreemapConfig) {
        var _custom4 = typeof customConfig == 'function' ? customConfig(TreemapConfig) : customConfig || {};
        configArr.push(buildTreemapConfiguration(TreemapConfig, series[0], seriesData, _custom4));
    } else if (XRangeConfig) {
        var _custom5 = typeof customConfig == 'function' ? customConfig(XRangeConfig) : customConfig || {};
        configArr.push(buildXRangeConfiguration(XRangeConfig, series[0], seriesData, _custom5));
    } else if (ChartConfig) {
        var ChartType = ChartConfig.ChartType;


        if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL) {
            var _custom6 = typeof customConfig == 'function' ? customConfig(ChartConfig) : customConfig || {};
            configArr.push(buildFunnelChartConfiguration(series[0], seriesData, _custom6));
        } else if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID) {
            var _custom7 = typeof customConfig == 'function' ? customConfig(ChartConfig) : customConfig || {};
            configArr.push(buildPyramidChartConfiguration(series[0], seriesData, _custom7));
        } else {
            configArr = series.reduce(function (acc, seriesConfig, i) {
                var custom = typeof customConfig == 'function' ? customConfig(seriesConfig) : customConfig || {};

                switch (ChartType.toLowerCase()) {
                    case 'pie':
                    case 'doughnut':
                        acc.push(buildPieConfiguration(seriesConfig, seriesData, custom));
                        break;
                    case 'bar':
                    case 'line':
                    case 'column':
                    case 'area':
                    case 'columnwithtarget':
                    case 'waterfall':
                    case 'boxplot':
                    case 'bubble':
                    case 'scatterplot':
                    case 'radialbar':
                    case 'arearange':
                    case 'lollipop':
                    case 'dumbbell':
                        acc.push(buildMultiAxisConfiguration(ChartConfig, seriesConfig, seriesData, custom, i));
                        break;
                    default:
                        return [];
                }
                return acc;
            }, []);
        }
    }
    return configArr.map(function (config, i) {
        return _extends({}, config, { id: 'id-' + i });
    });
};

export default configureSeries;